/** 
  Is used in layout/theme.liquid

  @example
  <script src="{{ 'integration.js' | asset_url }}" defer></script>
*/

(function () {
  window.__integration_exists = true;
  
  // todo: remove
  const HIDE_SELECTOR = 'div[data-rebuy-component-id="fd93d4bd-5f6f-4183-9e99-e756a4b43769"][data-rebuy-component="cross-sell-widget"]';
  const WARNING_SELECTOR = '#integration-warnings';
  const RECOMMENDATION_SELECTOR = '#integration-recommendations';
  const LOADER_SELECTOR = '#integration-loader';
  const CHECKOUT_BUTTON_SELECTOR = '.rebuy-button.rebuy-cart__checkout-button';

  const RECOMMENDATIONS_PAGE_SIZE = 3;

  // "Severity class"
  const SEVERITY_TEXT = 'Vakavuusluokka';

  let lastCartHash = '';
  let debounceTimer = null;

  window.handleWarningClose = function (event, btn) {
    event.stopPropagation();
    btn.closest('.integration__warning').remove();

    document.querySelectorAll(WARNING_SELECTOR).forEach((el) => {
      const remaining = Array.from(el.querySelectorAll('.integration__warning'));

      if (!remaining.length) {
        el.innerHTML = '';
        el.className = '';
        return;
      }

      const severityRank = { A: 0, B: 1, C: 2 };
      let highest = 'C';
      if (el.querySelector(".integration__warning--a")) {
        highest = 'A';
      } else if (el.querySelector(".integration__warning--b")) {
        highest = 'B';
      }

      el.className = `severity--${highest.toLowerCase()}`;

      const countBadge = el.querySelector('.integration__count-badge');
      if (countBadge) countBadge.textContent = remaining.length;

      const summary = el.querySelector('details > summary');
      if (summary) {
        // ? 'interaction warning' : 'interaction warnings';
        // const label = remaining.length === 1 ? 'huomio' : 'huomiota';
        Array.from(summary.childNodes)
          .filter((n) => n.nodeType === Node.TEXT_NODE)
          .forEach((n) => n.remove());
        const chevron = summary.querySelector('.integration__chevron');
        summary.insertBefore(document.createTextNode(` Huom! Valitsemillasi tuotteilla on yhteisvaikutuksia: `), chevron);
      }
    });
  };

  function closeHelpModal() {
    const modal = document.getElementById('contact-modal');
    if (modal) {
      modal.hidden = true;
      modal.style.display = "none";
    }
  }

  window.handleHelpClick = function (btn) {
    event.stopPropagation();
    event.preventDefault();

    const modal = document.getElementById('contact-modal');
    if (modal) {
      modal.hidden = false;
      modal.style.display = "flex";
      modal.querySelector(".modal").addEventListener("click", (e) => { e.preventDefault(); e.stopPropagation(); });
      modal.addEventListener("click", closeHelpModal);
    }
  };

  window.handleHelpClose = function (btn) {
    event.stopPropagation();
    event.preventDefault();
    closeHelpModal();
  };

  window.handleHelpModalClick = function (el) {
    // console.log(el)
  };

  function renderWarnings(warnings = []) {
    document.querySelectorAll(WARNING_SELECTOR).forEach((el) => {
      if (!warnings.length) {
        el.innerHTML = '';
        el.className = '';
        return;
      }

      // Highest severity: A > B > C
      const severityRank = { A: 0, B: 1, C: 2 };
      const highest = warnings.reduce((best, w) => {
        const rank = severityRank[w.severity.toUpperCase()] ?? 2;
        return rank < severityRank[best] ? w.severity.toUpperCase() : best;
      }, 'C');

      el.className = `severity--${highest.toLowerCase()}`;

      const TYPE_TRANSLATIONS = {
        alert: 'Varoitus',
        note: 'Huomio',
      };

      const items = warnings.map((w) => {
        // Need help? Ask a pharmacist
        const helpText = 'Tarvitsetko lääkeneuvontaa? Kysy farmaseutilta';
        const helpEl =
          w.severity.toUpperCase() === 'A'
            ? `<button class="integration__warning-help" onclick="handleHelpClick(this)">${helpText}</button>`
            : '';

        const typeLabel = TYPE_TRANSLATIONS[w.type?.toLowerCase()] ?? w.type;

        return `
          <li class="integration__warning integration__warning--${w.severity.toLowerCase()}">
            <button class="integration__warning-close" onclick="handleWarningClose(event, this)">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M18 6 6 18"/><path d="m6 6 12 12"/>
              </svg>
            </button>
            <p class="integration__warning-products-title">Seuraavilla tuotteilla on yhteisvaikutuksia:</p>
            <ul>
              <li>
                ${w.productA}
              </li>
              <li>
                ${w.productB}
              </li>
            </ul>
            <p class="integration__warning-desc">${w.riskDescription}</p>
            <p class="integration__warning-desc">${w.riskEffect}</p>
            ${helpEl}
          </li>
        `;
      });

      // warning badge
      // <p class="integration__warning-severity-badge">${SEVERITY_TEXT} ${w.severity.toUpperCase()}</p>
      // <p class="integration__warning-badge">${typeLabel}</p>
      // <p class="integration__warning-products">Seuraavilla tuotteilla on yhteisvaikutuksia: ${w.productA} ja ${w.productB}</p>

      // ? 'interaction warning' : `interaction warnings`;
      // const label = warnings.length === 1 ? 'huomio' : 'huomiota';

      el.innerHTML = `
        <details>
          <summary>
            <span class="integration__count-badge">${warnings.length}</span>
            Huom! Valitsemillasi tuotteilla on yhteisvaikutuksia:
            <span class="integration__chevron">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="m6 9 6 6 6-6"/>
              </svg>
            </span>
          </summary>
          <ul class="integration__warnings-list">
            ${items.join('')}
          </ul>
        </details>
      `;
    });
  }

  function renderRecommendations(recommendations = []) {
    document.querySelectorAll(RECOMMENDATION_SELECTOR).forEach((el) => {
      if (!recommendations.length) {
        el.innerHTML = '';
        return;
      }

      let expanded = false;

      function buildHTML() {
        const visible = expanded ? recommendations : recommendations.slice(0, RECOMMENDATIONS_PAGE_SIZE);
        const hasMore = !expanded && recommendations.length > RECOMMENDATIONS_PAGE_SIZE;

        const items = visible.map((r) => {
          return `
            <li class="integration__recommendation">
              <p class="integration__recommendation-badge">${r.message}</p>
              <div class="integration__recommendation-content" onclick="window.open('${r.link}', '_blank')" style="cursor:pointer">
                <img 
                  class="integration__recommendation-image" 
                  src="${r.image}" 
                  alt="Tuotekuva"
                  onerror="this.style.display='none'; this.nextElementSibling.style.display='flex';"
                />
                <div class="integration__recommendation-image-placeholder" style="display:none">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                    <rect width="18" height="18" x="3" y="3" rx="2"/><path d="M3 9h18M9 21V9"/>
                  </svg>
                </div>
              </div>
              <div class="integration__recommendation-right">
                <div class="integration__recommendation-texts">
                    <p class="integration__recommendation-title">${r.title}</p>
                    <p class="integration__recommendation-price">${r.price}</p>
                </div>
                <button
                  class="integration__recommendation-add-btn"
                  onclick="fetch(window.Shopify.routes.root + 'cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ id: '${r.variantId}', quantity: 1 })
                  }).then(() => {
                    const sectionId = document.querySelector('cart-items-component[data-drawer]')
                      ?.dataset?.sectionId;

                    if (!sectionId) return;

                    fetch(\`/?sections=\$\{sectionId\}\`)
                      .then(r => r.json())
                      .then(data => {
                        const html = data[sectionId];
                        if (!html) return;

                        const parser = new DOMParser();
                        const doc = parser.parseFromString(html, 'text/html');

                        const newCartItems = doc.querySelector('cart-items-component[data-drawer]');
                        const currentCartItems = document.querySelector('cart-items-component[data-drawer]');

                        if (newCartItems && currentCartItems) {
                          currentCartItems.innerHTML = newCartItems.innerHTML;
                        }

                        const newBubble = doc.querySelector('cart-icon .cart-bubble__text-count');
                        const currentBubble = document.querySelector('cart-icon .cart-bubble__text-count');
                        if (newBubble && currentBubble) {
                          currentBubble.textContent = newBubble.textContent;
                        }
                      });
                  })"
                >
                  Pakkauskoko
                </button>
              </div>
            </li>
          `;
        });

        // Show more
        const showMoreBtn = hasMore
          ? `<li class="integration__recommendation integration__recommendation--show-more">
               <button class="integration__recommendations-show-more">Näytä lisää</button>
             </li>`
          : '';

        el.innerHTML = `
          <h4>Lisää myös nämä</h4>
          <ul>
            ${items.join('')}
            ${showMoreBtn}
          </ul>
        `;

        if (hasMore) {
          el.querySelector('.integration__recommendations-show-more').addEventListener('click', (e) => {
            e.stopPropagation();
            expanded = true;
            buildHTML();
          });
        }
      }

      buildHTML();
    });
  }

  async function fetchCart() {
    const res = await fetch(window.Shopify.routes.root + 'cart.js');
    return await res.json();
  }

  function buildPayload(cart) {
    return {
      cartToken: cart.token,
      itemCount: cart.item_count,
      totalPrice: cart.total_price,
      items: cart.items.map((item) => ({
        id: item.id,
        variant_id: item.variant_id,
        product_id: item.product_id,
        key: item.key,
        quantity: item.quantity,
        title: item.product_title,
        variant_title: item.variant_title,
        sku: item.sku,
        vendor: item.vendor,
      })),
    };
  }

  async function runChecks() {
    const button = document.querySelector(CHECKOUT_BUTTON_SELECTOR);
    const loader = document.querySelector(LOADER_SELECTOR);
    const warnings = document.querySelector(WARNING_SELECTOR);
    const recommendations = document.querySelector(RECOMMENDATION_SELECTOR);

    let warningsData = [];

    try {
      button?.setAttribute('disabled', '');

      if (warnings) {
        warnings.innerHTML = '';
      }

      if (recommendations) {
        recommendations.innerHTML = '';
      }

      loader?.classList?.remove('hidden');
      if (loader) {
        loader.style.display = 'flex';
      }

      const cart = await fetchCart();
      const payload = buildPayload(cart);

      const [interactionResult, recommendationResult] = await Promise.allSettled([
        fetch('/apps/tools/interaction-check', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
        }).then((r) => r.json()),

        fetch('/apps/tools/recommendations', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
        }).then((r) => r.json()),
      ]);
      
      loader?.classList?.add('hidden');
      if (loader) {
        loader.style.display = 'none';
      }

      if (interactionResult.status === 'fulfilled') {
        warningsData = interactionResult.value?.warnings || [];
        renderWarnings(warningsData);
      } else {
        console.error('Interaction check failed:', interactionResult.reason);
      }

      if (recommendationResult.status === 'fulfilled') {
        renderRecommendations(recommendationResult.value?.recommendations || []);
      } else {
        console.error('Recommendations failed:', recommendationResult.reason);
      }
    } catch (error) {
      console.error('Medicine integration failed:', error);
    } finally {
      document.dispatchEvent(new CustomEvent('medicine:checks-done', {
        detail: { warnings: warningsData }
      }));

      button?.removeAttribute('disabled');
      loader?.classList?.add('hidden');
      if (loader) {
        loader.style.display = 'none';
      }
    }
  }

  function scheduleChecks() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      runChecks();
    }, 400);
  }

  function dispatchCartUpdated() {
    document.dispatchEvent(new CustomEvent('medicine:cart-updated'));
  }

  function patchFetch() {
    const originalFetch = window.fetch;

    window.fetch = async function (...args) {
      const response = await originalFetch.apply(this, args);

      const url = typeof args[0] === 'string' ? args[0] : args[0]?.url;

      if (
        url &&
        (url.includes('/cart/add') ||
          url.includes('/cart/change') ||
          url.includes('/cart/update') ||
          url.includes('/cart/clear'))
      ) {
        setTimeout(dispatchCartUpdated, 300);
      }

      return response;
    };
  }

  function patchXHR() {
    const originalOpen = XMLHttpRequest.prototype.open;
    const originalSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this._trackedUrl = url;
      return originalOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function () {
      this.addEventListener('load', () => {
        if (
          this._trackedUrl &&
          (this._trackedUrl.includes('/cart/add') ||
            this._trackedUrl.includes('/cart/change') ||
            this._trackedUrl.includes('/cart/update') ||
            this._trackedUrl.includes('/cart/clear'))
        ) {
          setTimeout(dispatchCartUpdated, 300);
        }
      });

      return originalSend.apply(this, arguments);
    };
  }

  function init() {
    patchFetch();
    patchXHR();

    document.addEventListener('medicine:cart-updated', scheduleChecks);

    // Run once on page load
    scheduleChecks();
  }

  document.addEventListener('DOMContentLoaded', init);

  const CART_SELECTOR = '#rebuy-cart';

  let wasOpen = false;

  const observer = new MutationObserver(() => {
    const cart = document.querySelector(CART_SELECTOR);
    if (!cart) return;

    const isOpen = cart.getAttribute('aria-hidden')?.toString() === 'false';

    if (isOpen && !wasOpen) {
      wasOpen = true;

      const hide = document.querySelector(HIDE_SELECTOR);
      if (hide) {
        //hide.style.display = "none"; //2026-08-25 Rebuy recommendations active again (for now)
      }

      document.querySelectorAll(WARNING_SELECTOR).forEach((el) => (el.innerHTML = ''));
      document.querySelectorAll(RECOMMENDATION_SELECTOR).forEach((el) => (el.innerHTML = ''));
      document.querySelector(LOADER_SELECTOR)?.classList?.remove('hidden');

      setTimeout(() => runChecks(), 1000);
    }

    if (!isOpen && wasOpen) {
      wasOpen = false;
      closeHelpModal();
    }
  });

  observer.observe(document.body, {
    subtree: true,
    attributes: true,
    childList: true,
  });
})();